var ALERTS_SETTING_ACTIONS = {
  fetchAlertsTypeOptions: 'FETCH_ALERTS_TYPE_OPTIONS',
  fetchingAlertsTypeOptionsSucceeded: 'FETCHING_ALERTS_TYPE_OPTIONS_SUCCEEDED',
  fetchingAlertsTypeOptionsFailed: 'FETCHING_ALERTS_TYPE_OPTIONS_FAILED',
  fetchAlertSchemas: 'FETCH_ALERT_SCHEMAS',
  fetchAlertSchemasSucceeded: 'FETCH_ALERT_SCHEMAS_SUCCEEDED',
  fetchAlertSchemasFailed: 'FETCH_ALERT_SCHEMAS_FAILED',
  createAlertSubscription: 'CREATE_ALERT_SUBSCRIPTION',
  updateAlertSubscription: 'UPDATE_ALERT_SUBSCRIPTION',
  deleteAlertSubscription: 'DELETE_ALERT_SUBSCRIPTION',
  alertSubscriptionSucceeded: 'ALERT_SUBSCRIPTION_SUCCEEDED',
  alertSubscriptionFailed: 'ALERT_SUBSCRIPTION_FAILED',
  toggleModalState: 'TOGGLE_MODAL_STATE',
  fetchAdminList: 'FETCH_ADMIN_LIST',
  fetchAdminListSucceeded: 'FETCH_ADMIN_LIST_SUCCEEDED',
  fetchAdminListFailed: 'FETCH_ADMIN_LIST_FAILED'
};
export default ALERTS_SETTING_ACTIONS;